import React from "react";
import { ConvertEnglish } from "../../../../components/ConterEnglsih";
import { webTittle } from "../../../sheard/webTittle";
import Accounting from "../Accounting/Accounting";
import CollectorAccounting from "../CollectorAccounting/CollectorAccounting";

const Dashboard = () => {
  webTittle("ডেসবোর্ড")

  return (
    <div className="mx-3">
      <h2 className='text-3xl m-5 font-bold '><ConvertEnglish english={"Dashboard"} bangla={"ডেসবোর্ড"} /></h2>
        <Accounting></Accounting>
        <CollectorAccounting></CollectorAccounting>
    </div>
  );
};

export default Dashboard;
